export default "__VITE_ASSET__DgSPrbGb__"